//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ProductBasicFields } from '@campaigns/components/shared/product-details-modal/details/ProductBasicFields';
import { ProductIdentifierFields } from '@campaigns/components/shared/product-details-modal/details/ProductIdentifierFields';
import { ProductImageSection } from '@campaigns/components/shared/product-details-modal/details/ProductImageSection';
import { ProductMetaFields } from '@campaigns/components/shared/product-details-modal/details/ProductMetaFields';
import { VariationBasicFields } from '@campaigns/components/shared/product-details-modal/details/VariationBasicFields';
import { ShippingAvailabilityDateField } from '@campaigns/components/shared/product-details-modal/form/ShippingAvailabilityDateField';

interface ProductDetailsTabProps {
  isViewOnly: boolean;
}

export const ProductDetailsTab = ({ isViewOnly }: ProductDetailsTabProps) => {
  return (
    <Container>
      <TwoColumnLayout>
        <PreviewColumn>
          <ProductImageSection isViewOnly={isViewOnly} />
        </PreviewColumn>

        <FieldsColumn>
          <ProductBasicFields isViewOnly={isViewOnly} />
          <ProductMetaFields isViewOnly={isViewOnly} />
          <ProductIdentifierFields isViewOnly={isViewOnly} />
          <ShippingAvailabilityDateField isViewOnly={isViewOnly} />
          <VariationBasicFields isViewOnly={isViewOnly} />
        </FieldsColumn>
      </TwoColumnLayout>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const TwoColumnLayout = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings[3]};
`;

const PreviewColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ theme }) => theme.smallMeasure};
`;

const FieldsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
  flex: 1;
`;
